import React from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";
import ClientLogo from "../components/ClientLogo";

const ClientsPage = () => {
  const clients = [
    {
      id: 1,
      name: "United Group",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhnte8EuItHgdKpHVqrzfNrcQvaBvXbArODpw_fuwa-FlLcyLWfttEZeQjHtxb4SdlDhTjWjXcnAX4IyZouF_Ox1EoDgsRWJitTwAQ8LFKg99UbvQ9iFuynmSFfcaTWOUkgyZNVMl-k0AwZDRzXCUuGT14KKh6wBN_XDlqbW0BH72w9AvQkkkkCF9fCZxg/s320/1.jpg",
    },
    {
      id: 2,
      name: "Reza Group",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgxRR8WiXpG63xwkrnbZY0fxsm_XPnYLLYB80o47OanCBu30HwMowcvEARBpGFcHDYGN6ETvx-ruE7UrKNd8yRqNdfnePsn2xU1YnNvXbyJ5o3JP8xcEDvL13SKrRy16yQXsgRXFG6AkJaam4C6gr2pFTdSHwdmx566mev3ujrnJgGVJPPT6eal2BkjHfE/s320/2.jpg",
    },
    {
      id: 3,
      name: "CRONY Group",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhaWkmzlLy4hCtv28Eeuwe49kuDeRmE3dBsdow1L_S1MwY0CvpvFNWeeYNR-izRlgEVUSIwk-qdxCk1Nh_zsv7-lRuInvlrEJ2PGQUABJXRTPO-L4b40TYnqhJO30SxZDgS0ik4Sw6tZK4AiHPAQ26JQDy3C2uYJcUBMWz06EZo0b246UzqgMJj_8YyI8w/s320/3.png",
    },
    {
      id: 4,
      name: "Bracket Limited",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjnSrsWMjawayIVvmJLdIynPXqTjE9hydHn3VjA10gtxEz5t9YToyJ8MqKN7dIZ0m339Qooz1QhAEzG4FLS6iVjJQIlX-TsnMFjm4yuqSr-2Ua9NKWJ7AIlZ9fV8A6BrOhw03vN9i4jc-93ftTuCWIsfdIuktDpjGYTBScAEJMOYHbR7IPKBkTLeE3Q7C8/s320/4.png",
    },
    {
      id: 5,
      name: "Export Tex",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEihyQgAcdvmmS5H1oTXhKKAWQEhAehwu99jwSiGlBhvL5PXYkrQp0sEwNOgiXDLIw3jfFdTCwr1GzC44OpOqyeJsZTiHrEWDNdGLF65gacqT1R0CSQDpfnJR-qI_YZkK-T2FF0UQWOtzJx___-Su_3mEQvVl1qpJ4uPRo2lB28KFFqJPUs9f0JvgXPMTyY/s320/5-EXPORT%20TEX.jpg",
    },
    {
      id: 6,
      name: "RS Technology",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgT4MgxUyMNzZJk5Csgz4EWJoiTnctGiN9kQJnTnxNeHPQjIGp2OuKDLnl_QFcCr3UCCJg5RSJrVPPk4m70rJoURvRPZrzg82ZG-1NNhLRt0dxDkOLeouaOuvk1l7e3JtPjINlqTzK8EizqF7g1In4Ku4X0dXoxVDbpbmpd-R0FRibG7N6nBp_f-ZIH5og/s320/6-Rs%20Technology.jpg",
    },
    {
      id: 7,
      name: "TEX Bridge",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhBSXztlUcLU1RXC1aKIAXt5bsyYTXmBpr29vqvbR0igc4RZtyENystC6bzJL8Q03ukQzR4GtxGYPmYZq3alyRCOnDjXZ5hautZoEiZKWY45y72dY1r5gYIuGiGbzgemoJkz2fBqgKsd87ZTssE7a36ewD9DTO1NgTjj5X6sqpR-MTlOToxwYEa4d5FdPc/s1600/8-Texbridge.png",
    },
    {
      id: 8,
      name: "CAFE Kabbo",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEgKLJaClVxFYS4fQc4BZb84xeI2jmW_2sp2zAZZfUQhgJNNXPvqmlNY7r_H0iTkE0QfmO7LsfOrEEIqK-er_EUjy5oWemx012T97dIW8IVh3GbhwSn4h8kOXLgmLj9QrDwQTAXg8ube4-Ng3oljkzoFrKWk5-jAtH6koCl3UIoV1eg4ijA4vEmjU1oWcJA/s320/9-Cafekabbo.jpg",
    },

    {
      id: 9,
      name: "Advance Agro",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEizt40v3X-lxRsBf2xzn2OxF-G7S3R4W-qS_vIwWtIQReMWr4A90VFAWBqC_ddYgNfrBTJ5dli9ggbNVwuvH74VK90JcX_XRPgp7aN76tW1H63aVS9fqLpSYuEP09d13BK9nekvETtV8KvReMbyH5GIoJJV8VxAYtTCXU7gwPCE5vlr9HTnnQzpUFpAiLc/s1600/WhatsApp%20Image%202025-06-21%20at%205.13.55%20PM.jpeg",
    },
    {
      id: 10,
      name: "Inspiration FItness and Diet COnsultancy Center",
      image:
        "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEissypRBzckQDqUsFERLMGOeVuHA7sznrUz6t-xun_k3NEE5sm-mwIfvl-dz-gsNtYceKHeSoHxXNXhIPzB3DRuMAO2Mv1irIShhJSUMqQWGPzYWb68XDzqiEgGV-maSziWPFlhOjNwdWexU5pj5GssEZ8TqYEowy7nRdn2onmBR52ZRztlXX7xoz6UXaU/s320/Inspiron%20Fitness%20and%20Diet%20Consultancy%20Center.jpg",
    },
  ];
  const testimonials = [
    {
      name: "Michael Chen",
      company: "TechSphere Inc.",
      position: "CEO",
      image: "https://images.pexels.com/photos/614810/pexels-photo-614810.jpeg",
      quote:
        "Venturex provided exceptional consulting services for our expansion into Bangladesh. Their deep understanding of the local market and regulations made our entry smooth and successful.",
      rating: 5,
    },
    {
      name: "Sarah Johnson",
      company: "EcoVentures",
      position: "Operations Director",
      image:
        "https://images.pexels.com/photos/1181686/pexels-photo-1181686.jpeg",
      quote:
        "The digital ecosystem strategy developed by Venturex transformed our business operations. We've seen remarkable improvements in efficiency and customer engagement.",
      rating: 5,
    },
    {
      name: "Ahmed Hassan",
      company: "GlobalTech Solutions",
      position: "Managing Director",
      image:
        "https://images.pexels.com/photos/2379004/pexels-photo-2379004.jpeg",
      quote:
        "Venturex handled our company registration and compliance requirements flawlessly. Their attention to detail and proactive approach saved us time and resources.",
      rating: 4,
    },
    {
      name: "Priya Sharma",
      company: "Innovative Enterprises",
      position: "Founder",
      image:
        "https://images.pexels.com/photos/3796217/pexels-photo-3796217.jpeg",
      quote:
        "Working with Venturex on our business innovation strategy has been a game-changer. Their insights and expertise helped us pivot our business model for sustained growth.",
      rating: 5,
    },
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="hero-pattern relative py-20 md:py-32">
        <div className="container relative z-10">
          <div className="max-w-3xl mx-auto text-center text-white">
            <motion.h1
              className="text-4xl md:text-5xl font-bold mb-6"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              Our Clients
            </motion.h1>
            <motion.p
              className="text-lg md:text-xl text-gray-200"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              Trusted by leading organizations and businesses worldwide
            </motion.p>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 w-full h-16 bg-gradient-to-t from-background to-transparent"></div>
      </section>

      {/* Clients Grid Section */}
      <section className="py-20">
        <div className="container">
          <div className="text-center mb-16">
            <motion.h2
              className="section-title"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              Companies We've Worked With
            </motion.h2>
            <motion.p
              className="section-subtitle"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              We're proud to have partnered with these leading organizations
              around the globe
            </motion.p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-12 items-center">
            {clients.map((client) => (
              <motion.div
                key={client.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.05 * client.id }}
                className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300"
              >
                <ClientLogo name={client.name} image={client.image} />
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Industries Section */}
      <section className="py-16 sm:py-20 relative bg-gray-50">
        {/* Subtle geometric pattern overlay */}
        <div className="absolute inset-0 geometric-pattern opacity-20 pointer-events-none"></div>

        <div className="relative z-10">
          <div className="container px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12 sm:mb-16">
              <motion.h2
                className="section-title"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
              >
                Industries We Serve
              </motion.h2>
              <motion.p
                className="section-subtitle max-w-2xl mx-auto"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                Our expertise spans across multiple industries and sectors
              </motion.p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {[
                {
                  name: "Technology",
                  description:
                    "From startups to established tech giants, we provide tailored solutions for software, hardware, and IT services companies.",
                },
                {
                  name: "Manufacturing",
                  description:
                    "Strategic guidance for manufacturing businesses looking to optimize operations, expand globally, or modernize with digital solutions.",
                },
                {
                  name: "Financial Services",
                  description:
                    "Comprehensive consulting for banks, fintech companies, and financial institutions navigating complex regulatory environments.",
                },
                {
                  name: "Retail & E-commerce",
                  description:
                    "Innovative strategies for retailers and e-commerce businesses to enhance customer experience and optimize supply chains.",
                },
                {
                  name: "Healthcare",
                  description:
                    "Specialized services for healthcare providers and medical technology companies focusing on compliance and innovation.",
                },
                {
                  name: "Education",
                  description:
                    "Forward-thinking solutions for educational institutions and EdTech companies transforming the learning landscape.",
                },
              ].map((industry, index) => (
                <motion.div
                  key={index}
                  className="bg-white p-6 sm:p-8 rounded-lg shadow-md"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.1 * index }}
                >
                  <h3 className="text-xl font-bold mb-3 text-primary">
                    {industry.name}
                  </h3>
                  <p className="text-text-light text-base leading-relaxed">
                    {industry.description}
                  </p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20">
        <div className="container">
          <div className="text-center mb-16">
            <motion.h2
              className="section-title"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              Client Testimonials
            </motion.h2>
            <motion.p
              className="section-subtitle"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              Hear what our clients have to say about working with us
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {testimonials.map((testimonial, index) => (
              <motion.div
                key={index}
                className="bg-white p-8 rounded-lg shadow-md"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 * index }}
              >
                <div className="flex items-center mb-6">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full object-cover"
                  />
                  <div className="ml-4">
                    <h3 className="text-xl font-bold text-primary">
                      {testimonial.name}
                    </h3>
                    <p className="text-secondary">
                      {testimonial.position}, {testimonial.company}
                    </p>
                  </div>
                </div>
                <div className="flex mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      size={16}
                      className={
                        i < testimonial.rating
                          ? "text-yellow-500 fill-current"
                          : "text-gray-300"
                      }
                    />
                  ))}
                </div>
                <p className="text-text-light italic">"{testimonial.quote}"</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-primary text-white">
        <div className="container">
          <div className="max-w-3xl mx-auto text-center">
            <motion.h2
              className="text-3xl md:text-4xl font-bold mb-6"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              Join Our Growing List of Satisfied Clients
            </motion.h2>
            <motion.p
              className="text-lg text-gray-200 mb-8"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              Contact us today to learn how Venturex can help your business
              succeed through our expert consulting services.
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.4 }}
            >
              <a href="#" className="btn-accent">
                Get Started
              </a>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ClientsPage;
